export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PollGames.vue?vue&type=template&id=79b6dc8f"


//////////////////
// WEBPACK FOOTER
// ./src/components/desktop/PollGames.vue?vue&type=template&id=79b6dc8f
// module id = 361
// module chunks = 3